import { ExpressionLoopPreventer } from './ExpressionLoopPreventer';

export const ExpressionFieldModule = {
  __init__: ['expressionLoopPreventer'],
  expressionLoopPreventer: ['type', ExpressionLoopPreventer],
};

export { ExpressionLoopPreventer };
